//1、引入axios
import axios from 'axios'
import qs from 'qs';
import store from '../store'
import url from './serveice.js'
import {
	Message,
	Loading
} from 'element-ui'
import router from '@/router/index.js'
//2、创建axios的实例
let httpService = axios.create({
	baseURL: url.url, //测试环境
	timeout: 20000,
})
let loadingInstance = null
let loading = false
let num=0
let tiem = null
//3、axios的拦截--request
httpService.interceptors.request.use(config => {
	num++
	// if(loadingInstance){
	// 	loadingInstance.close();
	// }
	loading = config.loading
	if(!loadingInstance && !loading){
		console.log(11)
		console.log("yyyy")
		loadingInstance = Loading.service({
			lock: true,
			text: '拼命加载中...',
			background: 'rgba(255,255,255,0.5)',
			target: ".content-container"
		});
	}
	
	// tiem=setTimeout(()=>{
	// 	loadingInstance = Loading.service({background:'rgba(0,0,0,0.1)'});
	// },2000)
	// 请求成功处理
	if (config.token) {
		config.headers.token = store.state.token
	}
	return config;
}, err => {
	num--
	if(num===0){
		console.log("ssss")
		setTimeout(function(){
			if(loadingInstance) {
				loadingInstance.close();
			}
			loadingInstance = null
		},500)
		
	}
	
	Promise.reject(err); // 请求错误处理
})

//4、axios的拦截--response
httpService.interceptors.response.use(response => {
	num--
	if(num===0){
		console.log("ssss")
		setTimeout(function(){
			if(loadingInstance) {
				loadingInstance.close();
			}
			loadingInstance = null
		},500)
		
	}
	// TODO:具体的code对应的处理可继续添加修改	
	// clearTimeout(tiem)
	// loadingInstance.close();
	if (response.data.code === 200) {
		return response;
	} else if (response.data.code === 403) {
		Message.error({
			message: response.data.msg ? response.data.msg : "服务器错误",
		});
		setTimeout(() => {
			router.push('/')

		}, 1000);
	} else {
		Message({
			message: response.data.msg ? response.data.msg : "请求错误",
			type: 'warning'
		});
		// setTimeout(() => {
		// 	router.push('/')
		// }, 1000);
	}

}, err => {
	num--
	if(num===0){
		console.log("ssss")
		setTimeout(function(){
			if(loadingInstance) {
				loadingInstance.close();
			}
			loadingInstance = null
		},500)
		
	}
	// console.log(err.response?err.response:"服务器错误");
	// loadingInstance.close();
	// clearTimeout(tiem)
	//loadingInstance.close();
	if (err.response) {
		Message.error({
			message: err.response.data.msg ? err.response.data.msg : "服务器错误",
		});
	} else {
		Message.error({
			message: "请求超时",
		});
	}

	// TODO:具体的code对应的处理可继续添加修改
	// if (err.response.code === 301) {
	// 	Message.error({
	// 		message: '登录过期',
	// 	});
	// 	console.log('');
	// 	//登录过期跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面 ---主页(index) 或者 退出到登录前的浏览的页面  
	// 	//这样登录页面登录接口成功之后可以进行跳转 主页(index) 或者 退出到登录前的页面： let path = this.$route.query.redirect || '/index.js';   this.$router.push(path);
	// 	setTimeout(() => {
	// 		this.$router.replace({
	// 			path: '/login',
	// 			query: {
	// 				redirect: this.$router.currentRoute.fullPath
	// 			}
	// 		});
	// 	}, 1000);
	// }
	// if (err.response.code === 500) {
	// 	Message.error({
	// 		message: err.response.msg?err.response.msg:"服务器错误",
	// 	});
	// }
	return Promise.reject(err);
})

//5、get请求的封装
export function get(url, params = {}, token = true, loading = false) {
	return new Promise((resolve, reject) => {
		params = qs.stringify(params)
		httpService({
			url: url + "?" + params,
			method: 'get',
			// params: params,
			token: token,
			loading: loading
		}).then(res => {
			resolve(res.data);
		}).catch(err => {
			reject(err);
		})
	})
}

//6、post请求封装  默认json格式:'Content-Type':'application/json',如果是文件上传，可以修改headers为 headers: { 'Content-Type': 'multipart/form-data' }
export function post(url, params = {}, token = true, headers = {
	'Content-Type': 'application/x-www-form-urlencoded'
}) {
	return new Promise((resolve, reject) => {
		httpService({
			url: url,
			method: 'post',
			data: params,
			headers: headers,
			token: token
		}).then(res => {
			resolve(res.data);
		}).catch(err => {
			reject(err);
		})
	})
}

export function put(url, params = {}, token = true, headers = {
	'Content-Type': 'application/x-www-form-urlencoded'
}) {
	return new Promise((resolve, reject) => {
		httpService({
			url: url,
			method: 'put',
			data: params,
			headers: headers,
			token: token
		}).then(res => {
			resolve(res.data);
		}).catch(err => {
			reject(err);
		})
	})
}

export function del(url, params = {}, token = true, headers = {
	'Content-Type': 'application/x-www-form-urlencoded'
}) {
	return new Promise((resolve, reject) => {
		httpService({
			url: url,
			method: 'delete',
			data: params,
			headers: headers,
			token: token
		}).then(res => {
			resolve(res.data);
		}).catch(err => {
			reject(err);
		})
	})
}


//7、将模块暴露
export default {
	get,
	post,
	put,
	del
}
